export enum PaymentMethod {
    Visa = 1,
    MasterCard = 2,
}
